export default {
  title: 'Connected Platforms',
  signIn: 'Log in',
  role: 'Role',
  noConnection: 'There is no connection here'
}